

// import { Route } from "react-router-dom";

// // New Pages
// import LoginPage from "../pages/LoginPage";
// import SignupPage from "../pages/SignupPage";

// // Components
// import DevopsQuestions from "../components/questions/DevopsQuestions";
// import Questions from "../components/questions/Questions";
// import SreScore from "../components/score/SreScore";
// import RecommendationPage from "../recommendations/RecommendationPage";
// import Contactus from "../components/ContactusPage";
// import InstructionsCard from "../components/instruction";
// import FinalCard from "../components/FinalCard";
// import MainLayout from "../components/MainLayout";
// import ProtectedRoute from "./ProtectedRoute";
// import HistoryPage from "../components/History/HistoryPage";
// import LandingPage from "../components/landingPage/LandingPage";
// import Profile from "../components/Profile";
// export default function UserRoutes() {
//   return (
//     <>
//       {/* PUBLIC ROUTES */}
//       <Route path="/" element={<LoginPage />} />
//       <Route path="/login" element={<LoginPage />} />
//       <Route path="/signup" element={<SignupPage />} />
//       <Route path="/contactus-page" element={<Contactus />} />

//       {/* FINAL PAGE MOVED BACK UNDER PROTECTED ROUTE */}


//       {/* PROTECTED ROUTES UNDER MAIN LAYOUT */}
//       <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>

//         <Route path="/instructions" element={<InstructionsCard />} />

//         <Route
//           path="/devops-questions"
//           element={<ProtectedRoute><DevopsQuestions /></ProtectedRoute>}
//         />

//         <Route
//           path="questions/:domain"
//           element={<ProtectedRoute><Questions /></ProtectedRoute>}
//         />

//         <Route
//           path="/sre-score"
//           element={<ProtectedRoute><SreScore /></ProtectedRoute>}
//         />

//         <Route
//           path="/recommendation-page"
//           element={<ProtectedRoute><RecommendationPage /></ProtectedRoute>}
//         />

//         {/* FINAL PAGE IS HERE ✔ PROTECTED */}
//         <Route
//           path="/final-page"
//           element={<ProtectedRoute><FinalCard /></ProtectedRoute>}
//         />

//         <Route
//           path="/history-page"
//           element={<ProtectedRoute><HistoryPage /></ProtectedRoute>}
//         />
//         <Route
//           path="/landing-page"
//           element={<ProtectedRoute><LandingPage /></ProtectedRoute>}
//         />
//          <Route
//           path="/Profile"
//           element={<ProtectedRoute><Profile /></ProtectedRoute>}
//         />
//       </Route>
     
//     </>
//   );
// }


import { Route } from "react-router-dom";

// New Pages
import LoginPage from "../pages/LoginPage";
import SignupPage from "../pages/SignupPage";

// Components
import DevopsQuestions from "../components/questions/DevopsQuestions";
import Questions from "../components/questions/Questions";
import SreScore from "../components/score/SreScore";
import RecommendationPage from "../recommendations/RecommendationPage";
import Contactus from "../components/ContactusPage";
import InstructionsCard from "../components/instruction";
import FinalCard from "../components/FinalCard";
import MainLayout from "../components/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import HistoryPage from "../components/History/HistoryPage";
import LandingPage from "../components/landingPage/LandingPage";
import Profile from "../components/Profile";
import ResumePage from "../pages/ResumePage";
import ViewEvaluationPage from "../pages/ViewEvaluationPage";
export default function UserRoutes() {
  return (
    <>
      {/* PUBLIC ROUTES */}
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/contactus-page" element={<Contactus />} />
      <Route path="/resume" element={<ResumePage />} />
      <Route path="/view-evaluation" element={<ViewEvaluationPage />} />

      {/* FINAL PAGE MOVED BACK UNDER PROTECTED ROUTE */}


      {/* PROTECTED ROUTES UNDER MAIN LAYOUT */}
      <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>

        <Route path="/instructions" element={<InstructionsCard />} />

        <Route
          path="/devops-questions"
          element={<ProtectedRoute><DevopsQuestions /></ProtectedRoute>}
        />

        <Route
          path="questions/:domain"
          element={<ProtectedRoute><Questions /></ProtectedRoute>}
        />

        <Route
          path="/sre-score"
          element={<ProtectedRoute><SreScore /></ProtectedRoute>}
        />

        <Route
          path="/recommendation-page"
          element={<ProtectedRoute><RecommendationPage /></ProtectedRoute>}
        />

        {/* FINAL PAGE IS HERE ✔ PROTECTED */}
        <Route
          path="/final-page"
          element={<ProtectedRoute><FinalCard /></ProtectedRoute>}
        />

        <Route
          path="/history-page"
          element={<ProtectedRoute><HistoryPage /></ProtectedRoute>}
        />
        <Route
          path="/landing-page"
          element={<ProtectedRoute><LandingPage /></ProtectedRoute>}
        />
         <Route
          path="/Profile"
          element={<ProtectedRoute><Profile /></ProtectedRoute>}
        />
      </Route>
     
    </>
  );
}